import type * as I from 'core/api/coreApiClient';
import theme, {
  makeStyles, ThemeColors,
} from 'core/utilities/theme';

export const shortInputWidth = '33%';

export const inTableInputMinWidth = {
  default: 150,
  InputAdvancedRemoteSelect: 180,
  InputAdvancedSelect: 180,
  DatePicker: 130,
  DatePickerWithTime: 240,
  InputNumber: 50,
};

// Fields have a different height, we need to add a small margin to offset the difference
// and align them perfectly
export const inTableInputMarginTop = {
  InputAdvancedRemoteSelect: 8,
  InputAdvancedSelect: 8,
  DatePicker: 0,
  InputText: 8,
  InputSelect: 4,
  InputNumber: 8,
};

interface MakeStylesProps {
  longFormStyle?: boolean;
  sideLabel?: boolean;
  modalLabel?: boolean;
  errorMsg?: I.Message[];
  minWidth?: string;
  inTable?: boolean;
  marginTop?: number;
}

export const inputStyles = makeStyles(({
  longFormStyle, sideLabel, modalLabel, errorMsg, minWidth, inTable, marginTop,
}: MakeStylesProps) => {
  let styles = {
    root: {},
    labelRoot: {},
    labelDisabled: {},
    labelShrink: {},
    inputRoot: {},
    shortInputRoot: {},
  };

  // Turn helper text color to orange if the severity is at the WARN level (and there is not one ERROR)
  if (errorMsg && errorMsg.length > 0 && !errorMsg.find((e) => e.severity === 'ERROR')) {
    styles = {
      ...styles,
      root: {
        '& .Mui-error': {
          color: 'inherit',
          '&.MuiInput-root:after': {
            borderBottomColor: ThemeColors.softWarning,
            // Keep a thin line
            borderBottomWidth: '1px',
          },
          '&.MuiInputLabel-root': {
            color: ThemeColors.softWarning,
          },
          // Legend field, i.e. CheckboxCollection
          '&.MuiFormLabel-root': {
            color: ThemeColors.softWarning,
          },
          '&.MuiFormHelperText-root': {
            color: ThemeColors.softWarning,
          },
        },
        // InputFile component upload button
        '& .MuiButton-outlinedError': {
          color: ThemeColors.softWarning,
          borderColor: ThemeColors.softWarning,
          '&:hover': {
            borderColor: ThemeColors.softWarning,
          },
        },
      },
    };
  }

  if (longFormStyle) {
    styles = {
      ...styles,
      labelRoot: {
        fontSize: 13,
      },
      labelDisabled: {
        fontSize: 13,
      },
      labelShrink: {
        fontSize: '1rem',
      },
      inputRoot: {
        fontWeight: 500,
        '&.Mui-disabled:before': {
          border: 0,
        },
      },
    };
  }

  if (longFormStyle && sideLabel) {
    styles = {
      ...styles,
      shortInputRoot: {
        fontWeight: 500,
        width: shortInputWidth,
      },
    };
  }

  if (inTable) {
    styles = {
      ...styles,
      root: {
        ...styles,
        ...(marginTop !== undefined ? { marginTop: `${marginTop}px` } : {}),
      },
      inputRoot: {
        fontSize: theme.typography.body2.fontSize,
        minWidth: minWidth || inTableInputMinWidth.default,
        '&.Mui-disabled:before': {
          border: 0,
        },
      },
    };
  }

  if (modalLabel) {
    styles = {
      ...styles,
      labelRoot: {
        fontSize: 14,
        fontWeight: 500,
      },
      labelDisabled: {
        fontSize: 14,
        fontWeight: 500,
      },
      labelShrink: {
        fontSize: '1rem',
        fontWeight: 'inherit',
      },
    };
  }

  return styles;
});

